WB.DataServices = WB.DataServices || {};

WB.DataServices.PageLayouts = function ($http, $q) {

    this.GetPageLayoutForAlias = function(alias) {
        return $q(function(resolve, reject) {
            $http({
                method: 'GET',
                url: '/api/page-layouts',
                params: { layout: alias }
            })
                .success(resolve)
                .error(function(data) {
                    reject(new Error('Unable to get page layouts.'));
                });
        });
    };

};
WB.DataServices.PageLayouts.$inject = ['$http', '$q'];

WB.Core.service('PageLayoutsDataService', WB.DataServices.PageLayouts);
